import sanitizeHtml from 'sanitize-html'

export default (value) => {
  return sanitizeHtml(value, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(['h1', 'h2', 'u', 's']),
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
    },
    allowedSchemes: sanitizeHtml.defaults.allowedSchemes.concat(['tel', 'mailto']),
    transformTags: {
      a: (tagName, attribs) => {
        const href = attribs.href || ''
        if (href.startsWith('tel:') || href.startsWith('mailto:')) {
          return { tagName, attribs }
        }
        return {
          tagName,
          attribs: { ...attribs, target: '_blank', rel: 'noopener noreferrer' },
        }
      },
    },
  })
}
